(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters-old"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const filterButton = document.getElementById('filterToggleButton');
  const filterContent = document.getElementById('filterContent');
  const resetButton = document.getElementById('resetFilters');
  const form = document.getElementById('FacetFiltersForm');
  
  if (!filterButton || !filterContent || !resetButton || !form) {
    console.error('One or more required elements are missing');
    return;
  }

  let isFilterOpen = false;
  filterContent.style.display = 'none';
  updateArrow();
  
  function updateArrow() {
    const arrow = filterButton.querySelector('svg');
    if (arrow) {
      arrow.style.transform = isFilterOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  }
  
  function toggleFilter() {
    isFilterOpen = !isFilterOpen;
    filterContent.style.display = isFilterOpen ? 'block' : 'none';
    updateArrow();
  }
  
  filterButton.addEventListener('click', function(e) {
    e.preventDefault();
    toggleFilter();
  });
  
  resetButton.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Reset all form inputs
    const inputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"], input[type="number"]');
    inputs.forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      } else if (input.type === 'number') {
        input.value = '';
      }
    });
    
    // Force a full page reload to reset all filters properly
    const baseUrl = window.location.pathname;
    window.location.href = baseUrl;
  });
  
  function handleFilterChange() {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams();
    
    for (const [key, value] of formData.entries()) {
      if (value) searchParams.append(key, value);
    }
    
    const productGrid = document.querySelector('#product-grid, .product-grid, [data-product-grid]');
    if (productGrid) {
      productGrid.style.opacity = '0.5';
      productGrid.style.pointerEvents = 'none';
    }
    
    const baseUrl = window.location.pathname;
    
    fetch(`${baseUrl}?${searchParams.toString()}&section_id={{ section.id }}`)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(text => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, 'text/html');
        
        // Update product grid
        const selectors = ['#product-grid', '.product-grid', '[data-product-grid]'];
        let newProductGrid;
        
        for (const selector of selectors) {
          newProductGrid = html.querySelector(selector);
          if (newProductGrid) break;
        }
        
        if (productGrid && newProductGrid) {
          productGrid.innerHTML = newProductGrid.innerHTML;
        }
        
        // Update URL without reload
        const newUrl = `${baseUrl}?${searchParams.toString()}`;
        window.history.replaceState({}, '', newUrl);
        
        updateActiveFiltersUI();
        updateAvailableFilters(html);
      })
      .catch(error => {
        console.error('Error:', error);
        window.location.href = `${baseUrl}?${searchParams.toString()}`;
      })
      .finally(() => {
        if (productGrid) {
          productGrid.style.opacity = '1';
          productGrid.style.pointerEvents = 'auto';
        }
      });
  }
  
  function updateAvailableFilters(html) {
    const newFilterGroups = html.querySelectorAll('.filter-group');
    
    document.querySelectorAll('.filter-group').forEach(currentGroup => {
      const groupName = currentGroup.dataset.filterGroup;
      if (!groupName) return;
      
      const newGroup = Array.from(newFilterGroups).find(g => g.dataset.filterGroup === groupName);
      if (!newGroup) return;
      
      // Get all current options
      const currentOptions = currentGroup.querySelectorAll('.filter-option, .color-swatch');
      
      // Create a map of existing values for quick lookup
      const existingValues = new Set();
      currentOptions.forEach(opt => {
        existingValues.add(opt.dataset.value);
      });
      
      // Get all options from the new group
      const newOptions = newGroup.querySelectorAll('.filter-option, .color-swatch');
      
      // Create a map of new available values
      const availableValues = new Set();
      newOptions.forEach(opt => {
        availableValues.add(opt.dataset.value);
      });
      
      // Remove options that no longer exist (except active ones)
      currentOptions.forEach(currentOption => {
        const value = currentOption.dataset.value;
        const isActive = currentOption.classList.contains('active') || 
                         (currentOption.parentElement && currentOption.parentElement.querySelector('input') && 
                          currentOption.parentElement.querySelector('input').checked);
        
        if (!availableValues.has(value) && !isActive) {
          // Remove the entire label element
          const label = currentOption.closest('label');
          if (label) {
            // Also remove the separator if it exists
            const nextElement = label.nextElementSibling;
            if (nextElement && nextElement.textContent === '/') {
              nextElement.remove();
            }
            label.remove();
          } else {
            currentOption.remove();
          }
        }
      });
      
      // Add new options that weren't there before
      newOptions.forEach(newOption => {
        const value = newOption.dataset.value;
        if (!existingValues.has(value)) {
          // Clone the new option and add it to our current group
          const newOptionClone = newOption.cloneNode(true);
          const container = newOption.closest('.filter-options, .color-swatch-container');
          const currentContainer = currentGroup.querySelector(`.${container.className}`);
          
          if (currentContainer) {
            currentContainer.appendChild(newOptionClone);
            
            // Add event listeners to the new elements
            const input = newOptionClone.querySelector('input');
            if (input) {
              input.addEventListener('change', function() {
                updateActiveFiltersUI();
                handleFilterChange();
              });
            }
          }
        }
      });
    });
  }
  
  function updateActiveFiltersUI() {
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    const radios = form.querySelectorAll('input[type="radio"]');
    const priceInputs = form.querySelectorAll('input[type="number"]');
    
    checkboxes.forEach(checkbox => {
      const label = checkbox.closest('label');
      if (!label) return;
      
      const textElement = label.querySelector('.filter-option') || 
                         label.querySelector('.color-swatch');
      if (textElement) {
        textElement.classList.toggle('active', checkbox.checked);
      }
    });
    
    radios.forEach(radio => {
      const label = radio.closest('label');
      if (!label) return;
      
      const textElement = label.querySelector('.filter-option');
      if (textElement) {
        textElement.classList.toggle('active', radio.checked);
      }
    });
    
    const activeCheckboxes = form.querySelectorAll('input[type="checkbox"]:checked');
    const activeRadios = form.querySelectorAll('input[type="radio"]:checked');
    const activePriceFilters = Array.from(priceInputs).filter(input => input.value !== '');
    const totalActive = activeCheckboxes.length + activeRadios.length + activePriceFilters.length;
    
    if (totalActive > 0) {
      resetButton.style.display = 'flex';
      resetButton.innerHTML = `
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 1L1 9M1 1L9 9" stroke="black" stroke-width="1.5"/>
        </svg>
        RESET (${totalActive})
      `;
    } else {
      resetButton.style.display = 'none';
    }
  }
  
  function bindEvents() {
    const inputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    inputs.forEach(input => {
      input.addEventListener('change', function() {
        updateActiveFiltersUI();
        handleFilterChange();
      });
    });
    
    const priceButtons = form.querySelectorAll('.apply-price-range');
    priceButtons.forEach(button => {
      button.addEventListener('click', handleFilterChange);
    });
    
    const priceInputs = form.querySelectorAll('input[type="number"]');
    priceInputs.forEach(input => {
      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          handleFilterChange();
        }
      });
    });
  }
  
  bindEvents();
  updateActiveFiltersUI();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const filterButton = document.getElementById('filterToggleButton');
  const filterContent = document.getElementById('filterContent');
  const resetButton = document.getElementById('resetFilters');
  const form = document.getElementById('FacetFiltersForm');
  const activeCategoryTitle = document.getElementById('activeCategoryTitle');
  const activeCategoryName = document.getElementById('activeCategoryName');
  
  if (!filterButton || !filterContent || !resetButton || !form) {
    console.error('One or more required elements are missing');
    return;
  }

  let isFilterOpen = false;
  filterContent.style.display = 'none';
  updateArrow();
  
  function updateArrow() {
    const arrow = filterButton.querySelector('svg');
    if (arrow) {
      arrow.style.transform = isFilterOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  }
  
  function toggleFilter() {
    isFilterOpen = !isFilterOpen;
    filterContent.style.display = isFilterOpen ? 'block' : 'none';
    updateArrow();
  }
  
  filterButton.addEventListener('click', function(e) {
    e.preventDefault();
    toggleFilter();
  });
  
  resetButton.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Reset all form inputs
    const inputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"], input[type="number"]');
    inputs.forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      } else if (input.type === 'number') {
        input.value = '';
      }
    });
    
    // Resetează titlul la "Shop"
    if (activeCategoryName) {
      activeCategoryName.textContent = '';
    }
    
    // Force a full page reload to reset all filters properly
    const baseUrl = window.location.pathname;
    window.location.href = baseUrl;
  });
  
  function updateActiveCategoryTitle() {
    const allActiveValues = [];
    
    // Colectăm toate valorile active din TOATE categoriile de filtre
    document.querySelectorAll('.filter-group').forEach(group => {
      const filterLabelElement = group.querySelector('.filter-label');
      if (filterLabelElement) {
        const filterName = filterLabelElement.textContent.trim();
        
        // Verificăm checkbox-urile bifate
        const activeCheckboxes = group.querySelectorAll('input[type="checkbox"]:checked');
        activeCheckboxes.forEach(checkbox => {
          const valueElement = checkbox.closest('label').querySelector('.filter-option, .color-swatch');
          if (valueElement) {
            if (valueElement.classList.contains('color-swatch')) {
              // Pentru culori, folosim valoarea din checkbox (numele culorii)
              allActiveValues.push(checkbox.value);
            } else {
              // Pentru celelalte, folosim textul afișat
              allActiveValues.push(valueElement.textContent.trim());
            }
          }
        });
        
        // Verificăm input-urile de preț completate
        const priceInputs = group.querySelectorAll('input[type="number"]');
        const minPrice = priceInputs[0]?.value;
        const maxPrice = priceInputs[1]?.value;
        
        if (minPrice || maxPrice) {
          let priceText = '';
          if (minPrice && maxPrice) {
            priceText = `${minPrice} - ${maxPrice}`;
          } else if (minPrice) {
            priceText = `From ${minPrice}`;
          } else if (maxPrice) {
            priceText = `Up to ${maxPrice}`;
          }
          allActiveValues.push(priceText);
        }
      }
    });
    
    // Actualizăm afișarea titlului
    if (activeCategoryName) {
      if (allActiveValues.length > 0) {
        // Afișăm doar numele valorilor, separate de virgulă
        activeCategoryName.textContent = allActiveValues.join(', ');
      } else {
        // Dacă nu sunt valori active, afișăm "Shop"
        activeCategoryName.textContent = '';
      }
    }
  }
  
  function handleFilterChange() {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams();
    
    for (const [key, value] of formData.entries()) {
      if (value) searchParams.append(key, value);
    }
    
    const productGrid = document.querySelector('#product-grid, .product-grid, [data-product-grid]');
    if (productGrid) {
      productGrid.style.opacity = '0.5';
      productGrid.style.pointerEvents = 'none';
    }
    
    const baseUrl = window.location.pathname;
    
    fetch(`${baseUrl}?${searchParams.toString()}&section_id={{ section.id }}`)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(text => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, 'text/html');
        
        // Update product grid
        const selectors = ['#product-grid', '.product-grid', '[data-product-grid]'];
        let newProductGrid;
        
        for (const selector of selectors) {
          newProductGrid = html.querySelector(selector);
          if (newProductGrid) break;
        }
        
        if (productGrid && newProductGrid) {
          productGrid.innerHTML = newProductGrid.innerHTML;
        }
        
        // Update URL without reload
        const newUrl = `${baseUrl}?${searchParams.toString()}`;
        window.history.replaceState({}, '', newUrl);
        
        updateActiveFiltersUI();
        updateAvailableFilters(html);
        updateActiveCategoryTitle(); // Actualizează titlul categoriilor active
      })
      .catch(error => {
        console.error('Error:', error);
        window.location.href = `${baseUrl}?${searchParams.toString()}`;
      })
      .finally(() => {
        if (productGrid) {
          productGrid.style.opacity = '1';
          productGrid.style.pointerEvents = 'auto';
        }
      });
  }
  
  function updateAvailableFilters(html) {
    const newFilterGroups = html.querySelectorAll('.filter-group');
    
    document.querySelectorAll('.filter-group').forEach(currentGroup => {
      const groupName = currentGroup.dataset.filterGroup;
      if (!groupName) return;
      
      const newGroup = Array.from(newFilterGroups).find(g => g.dataset.filterGroup === groupName);
      if (!newGroup) return;
      
      // Get all current options
      const currentOptions = currentGroup.querySelectorAll('.filter-option, .color-swatch');
      
      // Create a map of existing values for quick lookup
      const existingValues = new Set();
      currentOptions.forEach(opt => {
        existingValues.add(opt.dataset.value);
      });
      
      // Get all options from the new group
      const newOptions = newGroup.querySelectorAll('.filter-option, .color-swatch');
      
      // Create a map of new available values
      const availableValues = new Set();
      newOptions.forEach(opt => {
        availableValues.add(opt.dataset.value);
      });
      
      // Remove options that no longer exist (except active ones)
      currentOptions.forEach(currentOption => {
        const value = currentOption.dataset.value;
        const isActive = currentOption.classList.contains('active') || 
                         (currentOption.parentElement && currentOption.parentElement.querySelector('input') && 
                          currentOption.parentElement.querySelector('input').checked);
        
        if (!availableValues.has(value) && !isActive) {
          // Remove the entire label element
          const label = currentOption.closest('label');
          if (label) {
            // Also remove the separator if it exists
            const nextElement = label.nextElementSibling;
            if (nextElement && nextElement.textContent === '/') {
              nextElement.remove();
            }
            label.remove();
          } else {
            currentOption.remove();
          }
        }
      });
      
      // Add new options that weren't there before
      newOptions.forEach(newOption => {
        const value = newOption.dataset.value;
        if (!existingValues.has(value)) {
          // Clone the new option and add it to our current group
          const newOptionClone = newOption.cloneNode(true);
          const container = newOption.closest('.filter-options, .color-swatch-container');
          const currentContainer = currentGroup.querySelector(`.${container.className}`);
          
          if (currentContainer) {
            currentContainer.appendChild(newOptionClone);
            
            // Add event listeners to the new elements
            const input = newOptionClone.querySelector('input');
            if (input) {
              input.addEventListener('change', function() {
                updateActiveFiltersUI();
                handleFilterChange();
              });
            }
          }
        }
      });
    });
  }
  
  function updateActiveFiltersUI() {
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    const radios = form.querySelectorAll('input[type="radio"]');
    const priceInputs = form.querySelectorAll('input[type="number"]');
    
    checkboxes.forEach(checkbox => {
      const label = checkbox.closest('label');
      if (!label) return;
      
      const textElement = label.querySelector('.filter-option') || 
                         label.querySelector('.color-swatch');
      if (textElement) {
        textElement.classList.toggle('active', checkbox.checked);
      }
    });
    
    radios.forEach(radio => {
      const label = radio.closest('label');
      if (!label) return;
      
      const textElement = label.querySelector('.filter-option');
      if (textElement) {
        textElement.classList.toggle('active', radio.checked);
      }
    });
    
    const activeCheckboxes = form.querySelectorAll('input[type="checkbox"]:checked');
    const activeRadios = form.querySelectorAll('input[type="radio"]:checked');
    const activePriceFilters = Array.from(priceInputs).filter(input => input.value !== '');
    const totalActive = activeCheckboxes.length + activeRadios.length + activePriceFilters.length;
    
    if (totalActive > 0) {
      resetButton.style.display = 'flex';
      resetButton.innerHTML = `
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 1L1 9M1 1L9 9" stroke="black" stroke-width="1.5"/>
        </svg>
        RESET (${totalActive})
      `;
    } else {
      resetButton.style.display = 'none';
    }
    
    // Actualizează titlul categoriilor active
    updateActiveCategoryTitle();
  }
  
  function bindEvents() {
    const inputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    inputs.forEach(input => {
      input.addEventListener('change', function() {
        updateActiveFiltersUI();
        handleFilterChange();
      });
    });
    
    const priceButtons = form.querySelectorAll('.apply-price-range');
    priceButtons.forEach(button => {
      button.addEventListener('click', handleFilterChange);
    });
    
    const priceInputs = form.querySelectorAll('input[type="number"]');
    priceInputs.forEach(input => {
      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          handleFilterChange();
        }
      });
    });
  }
  
  bindEvents();
  updateActiveFiltersUI();
});
  } catch(e) { console.error(e); }
})();

})();
